import {PaymentTypes} from "shared/config/pricings";
import axios from "shared/api/axiosConfig";
import { decryptApiBodyToJson, decryptApiBodyToString, encryptApiBodyFromJSON, encryptApiBodyFromFormData } from "shared/api/cryptApiBody";

// eslint-disable-next-line react-hooks/rules-of-hooks
 export async function getUserCurrentPayments (userType) {
    try {

        const url = `client/payment_logs'`

        const body = new FormData()
        body.append('type', userType)


        const response = await axios.post(url, new FormData(), {
            // withCredentials: true,
        });

        if (response) {
            // console.log(response)
        }
    } catch (error) {
        // console.error(error);
    }
};


export async function getStripeConfig() {
    const urlAPI = 'client/stripe-config';
    try {
        const res = await axios.post(urlAPI, {}, {
            withCredentials: true, // cookies are included in cross-site requests.
        });

        return decryptApiBodyToString(res.data);
    } catch (error) {
        // console.error(error);
        return null
    }

}

export async function createPaymentIntent(body) {

    try {
        const url = `client/payment_intent`;
        const res = await axios.post(url, {
            encrypt: encryptApiBodyFromFormData(body),
        }, {
            withCredentials: true, // cookies are included in cross-site requests.
        })
        return decryptApiBodyToJson(res.data);
    } catch (error) {
        // console.error(error);
        return null
    }
}

// Abonnements : le serveur crée l'abonnement SANS essai gratuit et renvoie le
// client_secret du PaymentIntent de sa PREMIÈRE FACTURE. C'est ce secret que le
// PaymentElement confirme — il ne faut donc PAS créer de PaymentIntent nu à côté,
// ni rappeler create_subscription après coup : le client serait débité deux fois.
export async function createSubscriptionIntent(body) {

    try {
        const url = `client/subscription_intent`;
        const res = await axios.post(url, {
            encrypt: encryptApiBodyFromFormData(body),
        }, {
            withCredentials: true, // cookies are included in cross-site requests.
        })
        return decryptApiBodyToJson(res.data);
    } catch (error) {
        // Le serveur renvoie ses refus en clair (400/409) — par exemple un
        // abonnement déjà en cours sur cette offre.
        return { error: error?.response?.data?.error ?? null }
    }
}

// Paiement unique : le serveur émet une FACTURE et renvoie le client_secret de
// son PaymentIntent. Même encaissement qu'avec createPaymentIntent, mais rattaché
// à une facture (TVA visible). Le montant vient du catalogue Stripe quand l'offre
// y figure, plus de pricings.tsx.
export async function createInvoiceIntent(body) {

    try {
        const url = `client/invoice_intent`;
        const res = await axios.post(url, {
            encrypt: encryptApiBodyFromFormData(body),
        }, {
            withCredentials: true, // cookies are included in cross-site requests.
        })
        return decryptApiBodyToJson(res.data);
    } catch (error) {
        // Le serveur renvoie ses refus en clair (400/409) : on les remonte pour
        // que l'écran affiche la raison au lieu d'un message générique.
        return { error: error?.response?.data?.error ?? null }
    }
}

export async function sendEmailAfterPayment(body, paymentType) {
    let urlAPI = '';

    switch (paymentType) {
        case PaymentTypes.CREDIT: {
            urlAPI = 'client/after-credit-payment';
            break;
        }
        case PaymentTypes.ACCOMAPGNEMENT:
            urlAPI = 'client/accompagnement-subscription';
            break;
        case PaymentTypes.ID_TRACKER:
            urlAPI = 'client/idtracker-subscription';
            break;
        default:
            // console.error(`Unknown payment type: ${paymentType}`);
            return null;
    }
    return axios.post(urlAPI, {
        encrypt: encryptApiBodyFromFormData(body),
        type: body.type
    }, {
        withCredentials: true, // cookies are included in cross-site requests.
    })
}


export async function sendErrorPayment(body, paymentType) {
    let urlAPI = '';

    switch (paymentType) {
        case PaymentTypes.CREDIT: {
            urlAPI = 'client/credit-error-payment';
            break;
        }
        case PaymentTypes.ACCOMAPGNEMENT:
            urlAPI = 'client/accompagnement-error';
            break;
        case PaymentTypes.ID_TRACKER:
            urlAPI = 'client/idtracker-subscription-error';
            break;
        default:
            // console.error(`Unknown payment type: ${paymentType}`);
            return null;
    }
    return axios.post(urlAPI, {
        encrypt: encryptApiBodyFromFormData(body),
        type: body.type
    }, {
        withCredentials: true, // cookies are included in cross-site requests.
    })
}

export async function createCustomer(body) {

    try {
        const url = `client/create_customer`
        const res = await axios.post(url, {
            encrypt: encryptApiBodyFromFormData(body),
        }, {
            withCredentials: true, // cookies are included in cross-site requests.
        })
        return decryptApiBodyToJson(res.data);
    } catch (error) {
        // console.error(error);
        return null
    }
}
export async function createSubscription(body) {

    try {
        const url = `client/create_subscription`
        const res = await axios.post(url, {
            encrypt: encryptApiBodyFromFormData(body),
        }, {
            withCredentials: true, // cookies are included in cross-site requests.
        })
        return decryptApiBodyToJson(res.data);
    } catch (error) {
        // console.error(error);
        return null
    }
}

// --- Gestion de son propre abonnement -------------------------------------
// Aucune de ces fonctions n'envoie d'identifiant d'abonnement : le serveur agit
// sur celui de la session. C'est ce qui empêche d'agir sur l'abonnement d'autrui.

/** État lu en direct chez Stripe (terme, résiliation demandée, montant). */
export async function getSubscriptionStatus() {
    try {
        const res = await axios.post("client/subscription/status", {}, { withCredentials: true });
        return decryptApiBodyToJson(res.data);
    } catch (error) {
        return { error: error?.response?.data?.error ?? null }
    }
}

/** Résiliation à la fin de la période payée — le client garde son accès jusqu'au terme. */
export async function cancelSubscription() {
    try {
        const res = await axios.post("client/subscription/cancel", {}, { withCredentials: true });
        return decryptApiBodyToJson(res.data);
    } catch (error) {
        return { error: error?.response?.data?.error ?? null }
    }
}

/** Annule une résiliation demandée, tant que le terme n'est pas atteint. */
export async function reactivateSubscription() {
    try {
        const res = await axios.post("client/subscription/reactivate", {}, { withCredentials: true });
        return decryptApiBodyToJson(res.data);
    } catch (error) {
        return { error: error?.response?.data?.error ?? null }
    }
}

/**
 * Change l'offre de l'abonnement EXISTANT. On envoie le NOM de l'offre, pas un
 * identifiant de prix : le serveur le résout via le catalogue, sinon on pourrait
 * s'abonner au tarif de son choix.
 */
export async function changeSubscriptionOffer(offreName, offreId, type) {
    try {
        const body = new FormData();
        body.append("offreName", offreName);
        if (offreId != null) body.append("offreId", `${offreId}`);
        // `type` doit rester EN CLAIR à la racine du body : le middleware backend
        // userLoggedIn le lit dans `req.body.type` et rejette en 401 tout body non
        // vide qui n'en porte pas. Le mettre dans `encrypt` ne suffirait donc pas.
        // (Les voisines status/cancel/reactivate y échappent en postant `{}` : un
        // body VIDE est explicitement laissé passer par le middleware.)
        const res = await axios.post("client/subscription/change", {
            encrypt: encryptApiBodyFromFormData(body),
            type,
        }, { withCredentials: true });
        return decryptApiBodyToJson(res.data);
    } catch (error) {
        return { error: error?.response?.data?.error ?? null }
    }
}

export async function getPricesFromStripe(body) {

    try {
        const url = `client/stripe-prices-list`
        const res = await axios.post(url, body, {
            withCredentials: true, // cookies are included in cross-site requests.
        });
        return decryptApiBodyToJson(res.data);
    } catch (error) {
        // console.error(error);
        return null
    }
}
